import useFetch, { Status } from '../../../../../hooks/fetch.hook';

interface IMyInformation {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export default function MyInformation() {
  // === STATE ===
  const [{ status, data, httpResponseStatusCode }] = useFetch<IMyInformation>('/api/mittkonto/myinformation');

  return (
    <div className="my-information">
      <h2>Mina uppgifter</h2>
      {status === Status.loading && <p>Laddar...</p>}
      {status === Status.failed && httpResponseStatusCode === 401 && <p>Du är inte inloggad. Logga in för att se dina uppgifter.</p>}
      {status === Status.failed && httpResponseStatusCode === 403 && <p>Du har inte behörighet att se dina uppgifter.</p>}
      {status === Status.failed && httpResponseStatusCode !== 401 && httpResponseStatusCode !== 403 && <p>Något gick fel.</p>}
      {status === Status.success && data && (
        <ul>
          <li>
            {data.firstName} {data.lastName}
          </li>
          <li>{data.email}</li>
          <li>{data.phoneNumber}</li>
        </ul>
      )}
    </div>
  );
}
